package org.example.zone360.pages.players_Details.videosSection

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.runtime.snapshots.SnapshotStateList
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderLeft
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronDown
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronUp
import com.varabyte.kobweb.silk.components.icons.fa.FaClosedCaptioning
import com.varabyte.kobweb.silk.components.icons.fa.FaComment
import com.varabyte.kobweb.silk.components.icons.fa.FaPause
import com.varabyte.kobweb.silk.components.icons.fa.FaPlay
import com.varabyte.kobweb.silk.components.icons.fa.FaTag
import com.varabyte.kobweb.silk.components.icons.fa.FaTriangleExclamation
import com.varabyte.kobweb.silk.components.icons.fa.FaUpload
import com.varabyte.kobweb.silk.components.icons.fa.FaUser
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.example.zone360.utils.getTagSentences
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.CompletableDeferred
import kotlinx.coroutines.await
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.example.zone360.components.CommonButton
import org.example.zone360.components.CustomPagination
import org.example.zone360.components.KeywordChip
import org.example.zone360.components.ProgressIndicator
import org.example.zone360.components.VideoProgressSliderCustom
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.GetSentencesData
import org.example.zone360.pages.coachDetails.charts.CircularProgressIndicator
import org.example.zone360.pages.coachDetails.sessionAllDetails.SentenceAudioWaveform
import org.example.zone360.pages.dashboard.SectionTitle
import org.example.zone360.theme.Palette
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.APIEndPoints
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.mediaManagerUtils.AudioManager
import org.example.zone360.utils.Res
import org.example.zone360.utils.Strings
import org.example.zone360.utils.ToastID
import org.example.zone360.utils.UploadedType
import org.example.zone360.utils.mediaManagerUtils.VideoManager
import org.example.zone360.utils.getCurrentMilliseconds
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Video
import org.w3c.dom.Audio
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.HTMLVideoElement
import org.w3c.fetch.RequestInit
import org.w3c.files.File
import org.w3c.files.get
import org.w3c.xhr.FormData
import org.w3c.xhr.XMLHttpRequest
import kotlin.math.ceil

@Composable
fun VideosSection(
    breakpoint: Breakpoint,
    sitePalette: SitePalette,
    userId: String,
    message: (String) -> Unit,
    userVideosData: SnapshotStateList<String>,
    tagData: (List<GetSentencesData>) -> Unit,
    seasonId: String
) {
//
    val scope = rememberCoroutineScope()
    var videoUploadedType by remember { mutableStateOf(UploadedType.SharedByCoach) }
    var currentVideoIndex by remember { mutableStateOf(0) }
    var uploadProgress by remember { mutableStateOf(-1.0) }
    var uploadStatus by remember { mutableStateOf("") }
    val getSentences = remember { mutableStateListOf<GetSentencesData>() }
    var isManuallySeeking by remember { mutableStateOf(false) }
    var selectedFilter by remember { mutableStateOf("Keywords") }
    var expandedTranscriptMap by remember { mutableStateOf(mapOf<String, Boolean>()) }
//
    // Add these at the top of VideosSection alongside other remember states
    val currentAudioRefHighlight = remember { mutableStateOf<Audio?>(null) }
    val currentVideoRef = remember { mutableStateOf<HTMLVideoElement?>(null) }
    var currentlyPlayingIdHighlight by remember { mutableStateOf<String?>(null) }
    var loadingSessionIdHighlight by remember { mutableStateOf<String?>(null) }
    var audioProgress by remember { mutableStateOf(0f) }
    var isThisPlaying by remember { mutableStateOf(false) }
    var currentlyPlayingVideoId by remember { mutableStateOf<String?>(null) }
    var isVideoDurationPlaying by remember { mutableStateOf(false) }
    var videoProgress by remember { mutableStateOf(0f) }
    var isPlayingAllHighlight by remember { mutableStateOf(false) }
    var currentlyPlayingIndexHighlight by remember { mutableStateOf<Int?>(null) }
    var playingResetKey by remember { mutableStateOf(0) }
//
    var startIndex by remember { mutableStateOf(0) }

    val sentencesList = getSentences.toList()
    val filteredSentences = remember(sentencesList, selectedFilter) {
        when (selectedFilter) {
            "Keywords" -> sentencesList.filter { sentence ->
                sentence.keywords?.any { it.nameCategory.isBlank() && it.text.isNotBlank() } == true
            }
            "Names" -> sentencesList.filter { sentence ->
                sentence.keywords?.any { it.nameCategory.isNotBlank() && it.text.isNotBlank() } == true
            }
            else -> sentencesList
        }
    }
    val totalDots = filteredSentences.size

// Track the start index for pagination
    val totalDotsForDots = userVideosData.size

    val uploadFile: (File) -> Unit = { file ->
        uploadProgress = 0.0
        uploadStatus = "Initializing upload..."

        scope.launch {
            try {
                val chunkSize = 4 * 1024 * 1024 // 4MB
                val totalChunks = ceil(file.size.toDouble() / chunkSize).toInt()
                val extension = file.name.substringAfterLast('.', "mp4")
                val videoId = "video_${getCurrentMilliseconds()}.$extension"
                val chunkIds = mutableListOf<String>()

                uploadStatus = "Uploading $totalChunks chunks..."

                for (chunkIndex in 0 until totalChunks) {
                    val start = chunkIndex * chunkSize
                    val end = minOf(start + chunkSize, file.size.toInt())
                    val chunk = file.slice(start, end)
                    val chunkId = chunkIndex.toString().padStart(6, '0')
                    chunkIds.add(chunkId)

                    val formData = FormData().apply {
                        append("file", chunk, file.name)
                        append("chunk_id", chunkId)
                        append("video_id", videoId)
                    }

                    val xhr = XMLHttpRequest()
                    xhr.open(Strings.POST, APIEndPoints.Name.upload_chunks, true)

                    xhr.upload.onprogress = { event ->
                        if (event.lengthComputable) {
                            val progress = ((chunkIndex.toDouble() / totalChunks) * 100) +
                                    ((event.loaded.toDouble() / event.total.toDouble()) * (100.0 / totalChunks))
                            uploadProgress = progress
                        }
                    }

                    val chunkCompleted = CompletableDeferred<Boolean>()
                    xhr.onload = {
                        if (xhr.status.toInt() == 200) {
                            chunkCompleted.complete(true)
                        } else {
                            uploadStatus = "Error uploading chunk $chunkId"
                            chunkCompleted.completeExceptionally(Exception("Upload failed!"))
                        }
                    }
                    xhr.onerror = {
                        chunkCompleted.completeExceptionally(Exception("Upload error!"))
                    }

                    xhr.send(formData)
                    chunkCompleted.await()
                }

                // All chunks uploaded, now finalize
                val commitFormData = FormData().apply {
                        append("video_id", videoId)
                        chunkIds.forEach { append("chunk_ids", it) }
                        append("sessionID", "")
                        append("userID", userId)
                        append("organization", AppGlobal.userData.organization)
                        append("playerVideo", "true")
                }

                val commitResponse = window.fetch(
                    APIEndPoints.Name.commit_chunks,
                    RequestInit(
                        method = Strings.POST,
                        body = commitFormData
                    )
                ).await()

                if (commitResponse.ok) {
                    uploadStatus = "Upload complete!"
                    uploadProgress = 101.0

                    val publicUrl = "${Res.Video.base_Video_URL}$videoId"

                    userVideosData.add(publicUrl)
                    currentVideoIndex = userVideosData.size - 1

                    message("Video uploaded successfully!")
                    showToast("toastSuccess")
                } else {
                    uploadStatus = "Commit failed!"
                    uploadProgress = -1.0
                    showToast("toastError")
                }

            } catch (e: Exception) {
                uploadStatus = "Upload failed: ${e.message}"
                uploadProgress = -1.0
                showToast("toastError")
            }
        }
    }

    LaunchedEffect(userId, seasonId) {

        val getTagPlayerSentences = getTagSentences(
            organization = AppGlobal.userData.organization,
            domainType = "soccer",
            language = "en",
            playerID = userId,
            seasonID = AppGlobal.selectedSeasonId
        )
        getSentences.clear()
        getSentences.addAll(getTagPlayerSentences.data)
        tagData(getSentences)
    }

    LaunchedEffect(selectedFilter) {
        // Suspend audio
        currentlyPlayingIdHighlight?.let { playingId ->
            val playingSentence = filteredSentences.firstOrNull { it.id == playingId }
            playingSentence?.let {
                AudioManager.suspendDownload("${Res.Audio.audio_base_url}${it.sessionId}")
            }
        }
        // Suspend video
        currentlyPlayingVideoId?.let { playingId ->
            val playingSentence = filteredSentences.firstOrNull { it.id == playingId }
            playingSentence?.takeIf { it.videoFile.isNotEmpty() }?.let {
                VideoManager.suspendDownload(
                    "${Res.Video.base_Video_URL}${encodeFileName(it.videoFile)}",
                    "video_${it.id}"
                )
            }
        }
        startIndex = 0
    }


    val stopAllMedia: () -> Unit = {
        currentAudioRefHighlight.value?.pause()
        currentAudioRefHighlight.value = null
        currentlyPlayingIdHighlight = null
        loadingSessionIdHighlight = null
        audioProgress = 0f
        isThisPlaying = false

        currentVideoRef.value?.pause()
        currentVideoRef.value = null
        currentlyPlayingVideoId = null
        isVideoDurationPlaying = false
        videoProgress = 0f

        playingResetKey++ // cancels all running LaunchedEffect coroutines keyed on this
    }

    DisposableEffect(Unit) {
        onDispose { stopAllMedia() }
    }

    LaunchedEffect(videoUploadedType) {
        stopAllMedia()
    }

    LaunchedEffect(startIndex) {
        // Suspend audio
        currentlyPlayingIdHighlight?.let { playingId ->
            val playingSentence = filteredSentences.firstOrNull { it.id == playingId }
            playingSentence?.let {
                AudioManager.suspendDownload("${Res.Audio.audio_base_url}${it.sessionId}")
            }
        }

        // Suspend previous video — use currentlyPlayingVideoId, not index math
        currentlyPlayingVideoId?.let { playingId ->
            val playingSentence = filteredSentences.firstOrNull { it.id == playingId }
            playingSentence?.takeIf { it.videoFile.isNotEmpty() }?.let {
                val prevVideo = "${Res.Video.base_Video_URL}${encodeFileName(it.videoFile)}"
                VideoManager.suspendDownload(prevVideo, "video_${it.id}")
            }
        }

        stopAllMedia()

        // Prepare new sentence's video
        val currentSentence = filteredSentences.getOrNull(startIndex)
        currentSentence?.takeIf { it.videoFile.isNotEmpty() }?.let {
            val curVideo = "${Res.Video.base_Video_URL}${encodeFileName(it.videoFile)}"
            VideoManager.prepare(curVideo, "video_${it.id}")
        }
    }
    Box(
        modifier = Modifier
            .thenIf(videoUploadedType == UploadedType.SharedByPlayer){
                Modifier.height(600.px)
            }
            .margin(topBottom = if (breakpoint <= Breakpoint.MD) 10.px else 0.px)
            .fillMaxWidth()
            .backgroundColor(sitePalette.modalBackgroundColor.rgb)
            .boxShadow(
                offsetY = 1.px,
                blurRadius = 3.px,
                color = sitePalette.boxShadowColor.rgb
            )
            .border(1.px, style = LineStyle.Solid, color = sitePalette.textFieldBorderColor.rgb)
            .borderRadius(15.px)
            .padding(20.px)
    ) {
        Column(
            modifier = Modifier.fillMaxSize()
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                SectionTitle("Videos")
                if (videoUploadedType == UploadedType.SharedByPlayer && AppGlobal.userData.role == Strings.PLAYER ) {
                    Row(
                        Modifier.gap(10.px),
                        verticalAlignment = Alignment.CenterVertically
                    ) {


                        if (uploadProgress in 0.0..100.0) {
                            FaTriangleExclamation(
                                modifier = Modifier.color(sitePalette.primary.rgb)
                            )
                            FieldTitleTextNormalSimple(
                                "Closing or refreshing page will cancel uploading",
                                fontSize = 15.px,
                                fontWeight = 500,
                                color = sitePalette.primary.rgb
                            )

                            CircularProgressIndicator(
                                percentage = uploadProgress.toFloat(),
                                size = 40,
                                strokeWidth = 5,
                                fontSize = 10.px,
                                primaryColor = sitePalette.primary.rgb,
                                backgroundColor = Colors.LightGray
                            )
                        } else {
                            CommonButton(
                                text = "Upload Video",
                                icon = {
                                    FaUpload(
                                        size = IconSize.LG,
                                        modifier = Modifier.color(sitePalette.primary.rgb)
                                    )
                                },
                                width = 150.px,
                                height = 40.px,
                                borderColor = sitePalette.primary.rgb,
                                backgroundColor = Colors.Transparent,
                                textSpanColor = sitePalette.primary.rgb,
                                onCLick = {
                                    val fileInput = document.createElement("input") as HTMLInputElement
                                    fileInput.type = "file"
                                    fileInput.accept = "video/*"
                                    fileInput.onchange = { event ->
                                        val selectedFile = (event.target as HTMLInputElement).files?.get(0)
                                        if (selectedFile != null) {
                                            if (!selectedFile.type.startsWith("video/")) {
                                                message("Please select a valid video file")
                                                showToast(ToastID.ERROR)
                                            } else {
                                                uploadFile(selectedFile)
                                            }
                                        }
                                    }
                                    fileInput.click()
                                }
                            )
                        }

                    }
                }
            }
            Row(modifier = Modifier.fillMaxWidth().gap(if (breakpoint < Breakpoint.MD) 5.px else 15.px)
                .flexWrap(FlexWrap.Wrap),
                verticalAlignment = Alignment.CenterVertically )
            {
                val tabs = remember(AppGlobal.userData.role) {
                    listOf(
                        UploadedType.SharedByCoach to "Shared by Coach",
                        UploadedType.SharedByPlayer to if (AppGlobal.userData.role == Strings.PLAYER) "Uploaded by You" else "Uploaded by Player"
                    )
                }

                Row(
                    modifier = Modifier
                        .fillMaxWidth(if (window.screen.width > 570) 450.px else 100.percent)
                        .margin(topBottom = 10.px)
                        .borderRadius(6.px)
                        .flexWrap(FlexWrap.Wrap)
                        .backgroundColor(sitePalette.lightGrey.rgb)
                        .padding(leftRight = 5.px, topBottom = 4.px)
                        .border(1.px, style = LineStyle.Solid, color = Colors.LightGray),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    tabs.forEach { (type, label) ->
                        val isSelected = videoUploadedType == type
                        Box(
                            modifier = Modifier
                                .fillMaxWidth(if (window.screen.width > 570) 50.percent else 100.percent)
                                .borderRadius(4.px)
                                .cursor(Cursor.Pointer)
                                .padding(leftRight = 12.px, topBottom = 6.px)
                                .backgroundColor(if (isSelected) Palette.White.rgbLight else Colors.Transparent)
                                .onClick {
                                    videoUploadedType = type
                                    if (type == UploadedType.SharedByCoach) selectedFilter = "Keywords"
                                }
                                .boxShadow(
                                    offsetX = 0.px,
                                    offsetY = if (isSelected) 2.px else 0.px,
                                    blurRadius = if (isSelected) 16.px else 0.px,
                                    spreadRadius = null,
                                    color = sitePalette.boxShadowColor.rgb
                                ),
                            contentAlignment = Alignment.Center
                        ) {
                            FieldTitleTextNormalSimple(
                                text = label,
                                textAlign = TextAlign.Center,
                                fontWeight = 500,
                                fontSize = 16.px,
                                isClickable = true
                            )
                        }
                    }
                }
            }

            Row(modifier = Modifier.fillMaxWidth().gap(if (breakpoint < Breakpoint.MD) 5.px else 15.px)
                .flexWrap(FlexWrap.Wrap),
                verticalAlignment = Alignment.CenterVertically ) {
                if (videoUploadedType == UploadedType.SharedByCoach) {
                    Row(
                        modifier = Modifier.gap(6.px),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        listOf("Keywords", "Names").forEach { filter ->
                            val isSelected = selectedFilter == filter
                            val iconColor = if (isSelected) sitePalette.primary.rgb else Colors.Gray
                            Row(
                                modifier = Modifier
                                    .borderRadius(8.px)
                                    .padding(leftRight = 14.px, topBottom = 6.px)
                                    .backgroundColor(
                                        if (isSelected) sitePalette.primary.rgb.copyf(alpha = 0.1f)
                                        else Colors.Transparent
                                    )
                                    .border(
                                        width = 1.px,
                                        style = LineStyle.Solid,
                                        color = if (isSelected) sitePalette.primary.rgb else Colors.LightGray
                                    )
                                    .cursor(Cursor.Pointer)
                                    .onClick { if (!isSelected) selectedFilter = filter },
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                if (filter == "Keywords") {
                                    FaTag(
                                        modifier = Modifier.color(iconColor).margin(right = 5.px, bottom = (-2).px),
                                        size = IconSize.SM
                                    )
                                } else {
                                    FaUser(
                                        modifier = Modifier.color(iconColor).margin(right = 5.px),
                                        size = IconSize.SM
                                    )
                                }
                                FieldTitleTextNormalSimple(
                                    text = filter,
                                    fontSize = 13.px,
                                    fontWeight = if (isSelected) 500 else 400,
                                    color = if (isSelected) sitePalette.primary.rgb else Colors.Gray,
                                    isClickable = true
                                )
                            }
                        }
                    }
                }
            }
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .borderRadius(8.px)
                    .margin(topBottom = 5.px)
                    .align(Alignment.CenterHorizontally)
            )
            {
                Column(
                    modifier = Modifier.fillMaxSize(),
                    horizontalAlignment = Alignment.CenterHorizontally
                )
                {
                    if (videoUploadedType == UploadedType.SharedByPlayer) {
                        if (userVideosData.isEmpty()) {
                            Box(
                                modifier = Modifier.fillMaxSize().height(400.px),
                                contentAlignment = Alignment.Center
                            ) {
                                FieldTitleTextNormalSimple(
                                    text = "No data available",
                                    fontSize = 16.px,
                                    fontWeight = 500
                                )
                            }
                        } else {
                            // Uploaded video
                            LaunchedEffect(currentVideoIndex) {
                                delay(100)
                                val v = document.getElementById("uploaded_video_$currentVideoIndex") as? HTMLVideoElement
                                v?.onloadedmetadata = {
                                    val v2 = document.getElementById("uploaded_video_$currentVideoIndex") as? HTMLVideoElement
                                    if (v2 != null) {
                                        val isPortrait = v2.videoHeight > v2.videoWidth
                                        v2.style.objectFit = if (isPortrait) "contain" else "cover"
                                    }
                                    null
                                }
                            }
                            Box(
                                modifier = Modifier.fillMaxWidth()
                                    .height(400.px)
                                    .overflow(if (window.screen.width < 768) Overflow.Hidden else Overflow.Visible)
                            ) {
                                Video(
                                    attrs = {
                                        attr("src", userVideosData[currentVideoIndex])
                                        attr("controls", "true")
                                        attr("loop", "false")
                                        attr("muted", "true")
                                        attr("id", "uploaded_video_$currentVideoIndex")
                                        style {
                                            property("width", "100%")
                                            property("height", "100%")
                                            property("border-radius", "8px")
                                            property("object-fit", "cover")
                                        }
                                    }
                                )
                            }
                            if (totalDotsForDots > 1) {
                                CustomPagination(
                                    currentPage = currentVideoIndex,
                                    totalPages = totalDotsForDots,
                                    onPageChange = { index ->
                                        currentVideoIndex = index
                                    },
                                    sitePalette = sitePalette
                                )
                            }
                        }
                    } else {

                        if (filteredSentences.isNotEmpty()) {

                            filteredSentences.drop(startIndex)
                                .take(1)
                                .forEachIndexed { index, sentenceData ->
                                    val sessionId = sentenceData.id
                                    val fileName = sentenceData.videoFile
                                    val encodedFileName = encodeFileName(fileName)
                                    val getSentenceVideo = "${Res.Video.base_Video_URL}$encodedFileName"
                                    val isCustomVideo = sentenceData.category == "customVideo"


                                    LaunchedEffect(currentlyPlayingIdHighlight, playingResetKey) {
                                        isThisPlaying = currentlyPlayingIdHighlight == sessionId

                                        if (currentlyPlayingIdHighlight == sessionId) {
                                            val audioPlay = currentAudioRefHighlight.value
                                            audioPlay?.apply {
                                                while (currentTime < sentenceData.endTime) {
                                                    if (!isManuallySeeking) {
                                                        audioProgress = ((currentTime - sentenceData.startTime) / (sentenceData.endTime - sentenceData.startTime)).toFloat()
                                                    }
                                                    delay(100)
                                                    if (currentTime >= sentenceData.endTime) {
                                                        pause()
                                                        currentlyPlayingIdHighlight = null
                                                        currentAudioRefHighlight.value = null
                                                        audioProgress = 0f
                                                        isThisPlaying = false
                                                        break
                                                    }
                                                }
                                            }
                                        }
                                    }

                                    //// video variables
                                    val isExpanded = expandedTranscriptMap[sessionId] ?: false
                                    // Video row logic
                                    var isSeeking by remember { mutableStateOf(false) }
                                    var isHovered by remember { mutableStateOf(false) }
                                    var isBuffering by remember { mutableStateOf(false) }

                                    LaunchedEffect(currentlyPlayingVideoId, playingResetKey) {
                                        if (currentlyPlayingVideoId == sessionId) {
                                            val videoElement = currentVideoRef.value
                                            videoElement?.apply {
                                                currentTime = sentenceData.startTime
                                                play()
                                                while (currentTime < sentenceData.endTime) {
                                                    videoProgress = ((currentTime - sentenceData.startTime) / (sentenceData.endTime - sentenceData.startTime)).toFloat()
                                                    delay(100)
                                                    if (currentTime >= sentenceData.endTime) {
                                                        pause()
                                                        currentlyPlayingVideoId = null
                                                        currentVideoRef.value = null
                                                        videoProgress = 0f
                                                        break
                                                    }
                                                }
                                            }
                                        }
                                    }

                                    fun playVideoWithAudio(
                                        videoElement: HTMLVideoElement,
                                        audioElement: Audio?, // nullable audio
                                        startTime: Double,
                                        endTime: Double
                                    ) {
                                        var timeoutId: Int? = null
                                        var intervalId: Int? = null
                                        var lastKnownGoodTime = startTime


                                        isVideoDurationPlaying = true
                                        isSeeking = true

                                        val cleanup = {
                                            videoElement.pause()
                                            audioElement?.pause()
                                            videoElement.src = ""      // ← cancels buffering immediately
                                            videoElement.load()         // ← aborts pending network requests
                                            isVideoDurationPlaying = false
                                            videoProgress = 0f
                                            audioProgress = 0f
                                            currentlyPlayingVideoId = null
                                            currentVideoRef.value = null
                                            currentAudioRefHighlight.value = null


                                            videoElement.onwaiting = null
                                            videoElement.onplaying = null
                                            videoElement.oncanplay = null
                                            videoElement.ontimeupdate = null

                                            timeoutId?.let {
                                                window.clearTimeout(it)
                                            }

                                            intervalId?.let {
                                                window.clearInterval(it)
                                            }

                                        }

                                        videoElement.currentTime = startTime
                                        audioElement?.currentTime = startTime
                                        lastKnownGoodTime = startTime

                                        videoElement.ontimeupdate = {
                                            val audioTime = audioElement?.currentTime ?: videoElement.currentTime
                                            val timeDiff = kotlin.math.abs(videoElement.currentTime - audioTime)

                                            if (audioElement != null && timeDiff > 0.1) {
                                                audioElement.currentTime = videoElement.currentTime
                                            }

                                            videoElement.currentTime.also { lastKnownGoodTime = it }
                                        }

                                        videoElement.onwaiting = {
                                            isBuffering = true
                                            audioElement?.pause()

                                            timeoutId?.let {
                                                window.clearTimeout(it)
                                            }
                                        }

                                        videoElement.onplaying = {
                                            isBuffering = false

                                            if (audioElement != null && audioElement.paused) {
                                                audioElement.play()
                                            }

                                            timeoutId = window.setTimeout({
                                                cleanup()
                                            }, ((endTime - videoElement.currentTime) * 1000).toInt())

                                        }

                                        intervalId = window.setInterval({
                                            if (videoElement.currentTime >= endTime) {
                                                cleanup()
                                            }
                                        }, 200)

                                        videoElement.oncanplay = {
                                            isBuffering = false

                                            videoElement.play().then {
                                                if (audioElement != null) {
                                                    audioElement.play()
                                                }
                                            }.catch { error ->
                                                cleanup()
                                            }
                                        }
                                    }

///////
                                    val sentenceAudioUrl = "${Res.Audio.audio_base_url}${sentenceData.sessionId}"

                                            Column(modifier = Modifier.fillMaxWidth()) {
                                                Column(modifier = Modifier
                                                    .margin(left = 0.px, right = 10.px, top = 10.px, bottom = 0.px)
                                                    .fillMaxWidth()
                                                    .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                                                    .boxShadow(
                                                        offsetY = 1.px,
                                                        blurRadius = 3.px,
                                                        color = sitePalette.boxShadowColor.rgb
                                                    )
                                                    .border(1.px, style = LineStyle.Solid, color = sitePalette.textFieldBorderColor.rgb)
                                                    .borderRadius(15.px)
                                                    .padding(20.px)
                                                    ) {
                                                Row(modifier = Modifier.fillMaxWidth().margin(topBottom = 8.px).flexWrap(FlexWrap.Wrap)){
                                                    sentenceData.keywords?.forEach { keyword ->
                                                        KeywordChip(
                                                            keywordText = keyword.text,
                                                            keywordCategory = keyword.keywordCategory,
                                                            sitePalette = sitePalette

                                                        )
                                                    }
                                                }
                                                    if (sentenceData.videoFile.isEmpty()) {
                                                        Row(
                                                            modifier = Modifier.fillMaxWidth()
                                                                .margin(top = 10.px)
                                                                .height(40.px)
                                                                .borderRadius(8.px)
                                                                .padding(8.px)
                                                                .gap(8.px)
                                                                .backgroundColor(sitePalette.searchBackground.rgb),
                                                            verticalAlignment = Alignment.CenterVertically
                                                        )
                                                        {
                                                            Box(
                                                                modifier = Modifier.width(30.px)
                                                                    .height(28.px)
                                                                    .borderRadius(100.percent)
                                                                    .backgroundColor(if (currentlyPlayingIdHighlight == sessionId || loadingSessionIdHighlight == sessionId) sitePalette.primary.rgb else Colors.Transparent)
                                                                    .cursor(Cursor.Pointer)
                                                                    .onClick {
                                                                        isPlayingAllHighlight =
                                                                            false
                                                                        if (currentlyPlayingIdHighlight == sessionId) {
                                                                            currentAudioRefHighlight.value?.pause()
                                                                            currentlyPlayingIdHighlight =
                                                                                null
                                                                            currentlyPlayingIndexHighlight =
                                                                                null
                                                                            currentAudioRefHighlight.value =
                                                                                null
                                                                            audioProgress = 0f
                                                                        } else {
                                                                            currentAudioRefHighlight.value?.pause()
                                                                            loadingSessionIdHighlight = sessionId

                                                                            val audio = AudioManager.prepare(sentenceAudioUrl)
                                                                            audio.onloadeddata = {
                                                                                loadingSessionIdHighlight = null
                                                                                audio.currentTime = sentenceData.startTime
                                                                                audio.play()
                                                                                currentlyPlayingIdHighlight = sessionId
                                                                                currentlyPlayingIndexHighlight = index
                                                                                currentAudioRefHighlight.value = audio
                                                                            }
                                                                            audio.load()
                                                                        }
                                                                    },
                                                                contentAlignment = Alignment.Center
                                                            ) {
                                                                if (loadingSessionIdHighlight == sessionId) {
                                                                    ProgressIndicator(10.px)
                                                                } else if (currentlyPlayingIdHighlight == sessionId) {
                                                                    FaPause(
                                                                        modifier = Modifier.color(
                                                                            Palette.White.rgbLight
                                                                        )
                                                                            .margin(right = 1.px),
                                                                        size = IconSize.XS
                                                                    )
                                                                } else {
                                                                    Image(
                                                                        src = Res.Images.play_all_button,
                                                                        modifier = Modifier.size(30.px)
                                                                    )
                                                                }
                                                            }
                                                            SentenceAudioWaveform(
                                                                modifier = Modifier.weight(1f),
                                                                progress = audioProgress,
                                                                startTime = sentenceData.startTime,
                                                                endTime = sentenceData.endTime,
                                                                isPlaying = isThisPlaying,
                                                                onProgressChange = { newProgress ->
                                                                    if (currentlyPlayingIdHighlight != sessionId) return@SentenceAudioWaveform

                                                                    // ❗ Ignore invalid zero-clicks that are actually misfires
                                                                    if (newProgress == 0f) {
                                                                        console.log("⚠️ Ignored zero-progress click — likely a misfire.")
                                                                        return@SentenceAudioWaveform
                                                                    }

                                                                    isManuallySeeking = true
                                                                    audioProgress = newProgress

                                                                    currentAudioRefHighlight.value?.let { audio ->
                                                                        val seekTime =
                                                                            sentenceData.startTime + (sentenceData.endTime - sentenceData.startTime) * newProgress
                                                                        console.log("✅ Seeking to seekTime: $seekTime from progress: $newProgress")

                                                                        // ✅ Accurate sync using onseeked
                                                                        audio.onseeked = {
                                                                            console.log("🎯 onseeked triggered — syncing audioProgress.")
                                                                            audioProgress =
                                                                                ((audio.currentTime - sentenceData.startTime) / (sentenceData.endTime - sentenceData.startTime)).toFloat()
                                                                            isManuallySeeking =
                                                                                false
                                                                            null.also {
                                                                                audio.onseeked = it
                                                                            } // Remove listener after firing
                                                                        }

                                                                        audio.currentTime = seekTime
                                                                    }
                                                                }
                                                            )
                                                            Row() {
                                                                FieldTitleTextNormalSimple(
                                                                    text = run {
                                                                        val elapsed =
                                                                            ((sentenceData.totalTime * audioProgress).toInt())
                                                                        val m = elapsed / 60
                                                                        val s = elapsed % 60
                                                                        "${m}:${
                                                                            s.toString()
                                                                                .padStart(2, '0')
                                                                        }"
                                                                    },
                                                                    fontSize = 12.px,
                                                                    fontWeight = 400,
                                                                    color = sitePalette.textFieldTextColor.rgb
                                                                )

                                                                FieldTitleTextNormalSimple(
                                                                    text = run {
                                                                        val total =
                                                                            sentenceData.totalTime.toInt()
                                                                        val m = total / 60
                                                                        val s = total % 60
                                                                        "/${m}:${
                                                                            s.toString()
                                                                                .padStart(2, '0')
                                                                        }"
                                                                    },
                                                                    fontSize = 12.px,
                                                                    fontWeight = 400,
                                                                    color = sitePalette.textFieldTextColor.rgb
                                                                )
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        Box(
                                                            modifier = Modifier.fillMaxWidth()
                                                        .height(400.px)
                                                        .onMouseEnter { isHovered = true }
                                                        .onMouseLeave { isHovered = false },
                                                    contentAlignment = Alignment.Center
                                                )
                                                {
                                                    if (!isVideoDurationPlaying) {
                                                        Box(
                                                            modifier = Modifier.size(54.px)
                                                                .zIndex(9999)
                                                                .borderRadius(100.percent)
                                                                .backgroundColor(sitePalette.primary.rgb)
                                                                .cursor(Cursor.Pointer)
                                                                .onClick {
                                                                    val videoElement = document.getElementById("video_$sessionId") as? HTMLVideoElement
                                                                    videoElement?.let { video ->
                                                                        val audio = if (!isCustomVideo) AudioManager.prepare(sentenceAudioUrl) else null
                                                                        currentlyPlayingVideoId = sessionId
                                                                        currentVideoRef.value = video
                                                                        currentAudioRefHighlight.value = audio
                                                                        isVideoDurationPlaying = true
                                                                        isBuffering = true  // ← show loader immediately

                                                                        if (video.src.isEmpty() || !video.src.contains(getSentenceVideo.substringAfterLast("/"))) {
                                                                            // src was cleared — restore it first
                                                                            video.src = getSentenceVideo
                                                                            video.load()
                                                                            video.oncanplay = {
                                                                                video.oncanplay = null
                                                                                video.currentTime = sentenceData.startTime
                                                                                video.onseeked = {
                                                                                    video.onseeked = null
                                                                                    playVideoWithAudio(video, audio, sentenceData.startTime, sentenceData.endTime)
                                                                                }
                                                                            }
                                                                        } else {
                                                                            video.currentTime = sentenceData.startTime
                                                                            video.onseeked = {
                                                                                video.onseeked = null
                                                                                playVideoWithAudio(video, audio, sentenceData.startTime, sentenceData.endTime)
                                                                            }
                                                                        }
                                                                    }
                                                                },
                                                            contentAlignment = Alignment.Center
                                                        ) {
                                                            FaPlay(
                                                                size = IconSize.XL,
                                                                modifier = Modifier.color(Colors.White)
                                                                    .margin(
                                                                        top = 2.px,
                                                                        left = 2.5.px
                                                                    )

                                                            )
                                                        }
                                                    } else {
                                                        if (isHovered ||  isBuffering) {
                                                            Box(
                                                                modifier = Modifier.size(54.px)
                                                                    .zIndex(9999)
                                                                    .borderRadius(100.percent)
                                                                    .backgroundColor(sitePalette.primary.rgb)
                                                                    .cursor(Cursor.Pointer)
                                                                    .onClick {
                                                                        val videoElement =
                                                                            document.getElementById(
                                                                                "video_$sessionId"
                                                                            ) as? HTMLVideoElement
                                                                        val audioElement =
                                                                            currentAudioRefHighlight.value

                                                                        videoElement?.let {
                                                                            isVideoDurationPlaying =
                                                                                false
                                                                            it.pause()
                                                                            audioElement?.pause()
                                                                            currentlyPlayingVideoId =
                                                                                null
                                                                            currentVideoRef.value =
                                                                                null
                                                                            currentAudioRefHighlight.value =
                                                                                null
                                                                        }
                                                                    },
                                                                contentAlignment = Alignment.Center
                                                            ) {
                                                                if (isBuffering) {
                                                                    ProgressIndicator()
                                                                } else {
                                                                    FaPause(
                                                                        size = IconSize.XL,
                                                                        modifier = Modifier.color(
                                                                            Colors.White
                                                                        )
                                                                            .margin(top = 1.px)

                                                                    )
                                                                }
                                                            }
                                                        }
                                                    }

                                                    Box(
                                                        modifier = Modifier.align(Alignment.BottomCenter)
                                                            .height(90.percent)
                                                            .fillMaxWidth()
                                                    ) {
                                                        if (isHovered) {
                                                            if (isVideoDurationPlaying) {
                                                                VideoProgressSliderCustom(
                                                                    modifier = Modifier.fillMaxWidth(
                                                                        97.percent
                                                                    )
                                                                        .align(Alignment.BottomCenter)
                                                                        .margin(bottom = 20.px)
                                                                        .zIndex(9999),
                                                                    progress = videoProgress,
                                                                    onProgressChange = { newProgress ->
                                                                        val videoElement =
                                                                            document.getElementById(
                                                                                "video_$sessionId"
                                                                            ) as? HTMLVideoElement
                                                                        val audioElement =
                                                                            currentAudioRefHighlight.value

                                                                        videoElement?.let { video ->
                                                                            val newTime =
                                                                                sentenceData.startTime + (newProgress * (sentenceData.endTime - sentenceData.startTime))
                                                                            video.currentTime =
                                                                                newTime
                                                                            audioElement?.currentTime =
                                                                                newTime

                                                                            // Update progress state
                                                                            videoProgress =
                                                                                ((newTime - sentenceData.startTime) / (sentenceData.endTime - sentenceData.startTime)).toFloat()

                                                                            // 🚫 FIX: Prevent AbortError on seek
                                                                            try {
                                                                                video.pause()
                                                                                audioElement?.pause()
                                                                            } catch (e: dynamic) {
                                                                                console.warn(
                                                                                    "Pause error (can ignore):",
                                                                                    e
                                                                                )
                                                                            }

                                                                            // ✅ Delay briefly to avoid overlapping with current pause cycle
                                                                            scope.launch {
                                                                                delay(100) // wait for pause to resolve
                                                                                try {
                                                                                    video.play()
                                                                                    audioElement?.play()
                                                                                } catch (e: dynamic) {
                                                                                    console.warn(
                                                                                        "Play error (can ignore):",
                                                                                        e
                                                                                    )
                                                                                }
                                                                            }
                                                                        }
                                                                    }

                                                                )
                                                            }
                                                        }

                                                        LaunchedEffect(sessionId) {
                                                            val videoElement =
                                                                document.getElementById("video_$sessionId") as? HTMLVideoElement
                                                            if (!isCustomVideo) {
                                                                videoElement?.muted = true
                                                            }
                                                            videoElement?.onloadedmetadata = {
                                                                val isMobile = window.screen.width < 768
                                                                val isPortrait = videoElement.videoHeight > videoElement.videoWidth
                                                                videoElement.style.objectFit = when {
                                                                    isMobile -> "contain"           // always show full video on mobile (black bars)
                                                                    isPortrait -> "contain"         // portrait on desktop — no crop
                                                                    else -> "cover"                 // landscape on desktop — fill nicely
                                                                }
                                                                videoElement.style.backgroundColor = "black"  // black bars instead of white/transparent
                                                                null
                                                            }
                                                        }
                                                        Video(
                                                            attrs = {
                                                                attr("id", "video_$sessionId")
                                                                attr("preload", "none")
                                                                attr("playsinline", "true")
                                                                attr("webkit-playsinline", "true")
                                                                style {
                                                                    property("width", "100%")
                                                                    property("height", "100%")
                                                                    property("border-radius", "8px")
                                                                    property("object-fit", "cover")
                                                                    property("background-color", "black")
                                                                    property("align", "bottom center")
                                                                }
                                                            }
                                                        )
                                                    }
                                                }
                                                    }
                                                    Column(
                                                        modifier = Modifier.margin(topBottom = 7.px)
                                                            .fillMaxWidth()
                                                            .maxHeight(150.px)
                                                            .overflow(
                                                                overflowY = Overflow.Auto,
                                                                overflowX = Overflow.Hidden
                                                            )
                                                    ) {
                                                        if (sentenceData.notes.isNotEmpty()) {
                                                            Column(
                                                                modifier = Modifier.fillMaxWidth()
                                                                    .padding(10.px)
                                                                    .backgroundColor(
                                                                        sitePalette.primary.rgb.copyf(
                                                                            alpha = 0.1f
                                                                        )
                                                                    )
                                                                    .borderLeft(
                                                                        width = 5.px,
                                                                        style = LineStyle.Solid,
                                                                        color = sitePalette.primary.rgb
                                                                    )
                                                            ) {
                                                                Row(
                                                                    modifier = Modifier.margin(
                                                                        bottom = 3.px
                                                                    ),
                                                                    verticalAlignment = Alignment.CenterVertically,
                                                                ) {
                                                                    FaComment(
                                                                        modifier = Modifier.color(
                                                                            sitePalette.primary.rgb
                                                                        )
                                                                            .margin(right = 5.px)
                                                                    )
                                                                    FieldTitleTextNormalSimple(
                                                                        text = "Coach Note",
                                                                        fontSize = 15.px,
                                                                        fontWeight = 600,
                                                                        width = 100.percent,
                                                                        color = sitePalette.primary.rgb
                                                                    )
                                                                }
                                                                FieldTitleTextNormalSimple(
                                                                    text = sentenceData.notes,
                                                                    fontSize = 14.px,
                                                                    fontWeight = 500,
                                                                    width = 100.percent
                                                                )
                                                            }

                                                        }
                                                    }

                                                    if (sentenceData.transcript.isNotEmpty()) {
                                                        Column(
                                                            modifier = Modifier.margin(bottom = 7.px)
                                                                .fillMaxWidth()
                                                                .backgroundColor(sitePalette.seasonMutedText.rgb)
                                                                .borderRadius(8.px)
                                                                .padding(10.px)
                                                        ) {
                                                            Row(
                                                                modifier = Modifier.fillMaxWidth(),
                                                                verticalAlignment = Alignment.CenterVertically,
                                                                horizontalArrangement = Arrangement.SpaceBetween
                                                            ) {
                                                                Row(verticalAlignment = Alignment.CenterVertically) {
                                                                    FaClosedCaptioning(
                                                                        modifier = Modifier.color(sitePalette.textFieldTextColor.rgb).margin(right = 5.px)
                                                                    )
                                                                    FieldTitleTextNormalSimple(
                                                                        text = "Transcript",
                                                                        fontSize = 15.px,
                                                                        fontWeight = 600,
                                                                        color = sitePalette.textFieldTextColor.rgb
                                                                    )
                                                                }
                                                                if (isExpanded) {
                                                                    FaChevronUp(
                                                                        modifier = Modifier.color(Colors.Gray).cursor(Cursor.Pointer)
                                                                            .onClick { expandedTranscriptMap = expandedTranscriptMap - sessionId }
                                                                    )
                                                                } else {
                                                                    FaChevronDown(
                                                                        modifier = Modifier.color(Colors.Gray).cursor(Cursor.Pointer)
                                                                            .onClick { expandedTranscriptMap = expandedTranscriptMap + (sessionId to true) }
                                                                    )
                                                                }
                                                            }
                                                            if (isExpanded) {
                                                                FieldTitleTextNormalSimple(
                                                                    text = sentenceData.transcript,
                                                                    fontSize = 14.px,
                                                                    fontWeight = 500,
                                                                    width = 100.percent,
                                                                    marginTop = 6.px
                                                                )
                                                            }
                                                        }
                                                    }
                                                }
                                                Column(modifier = Modifier.fillMaxWidth()) {

                                                    if (filteredSentences.size > 1) {
                                                        CustomPagination(
                                                            currentPage = startIndex,
                                                            totalPages = totalDots,
                                                            onPageChange = { index1 ->
                                                                startIndex = index1
                                                            },
                                                            sitePalette = sitePalette
                                                        )
                                                    }
                                                }
                                            }
                                }

                        } else {
                            Box(
                                modifier = Modifier.fillMaxSize(),
                                contentAlignment = Alignment.Center
                            ) {
                                FieldTitleTextNormalSimple(
                                    text = "No data available",
                                    fontSize = 16.px,
                                    fontWeight = 500,
                                    marginTop = 20.px,
                                    marginBottom = 20.px
                                )
                            }
                        }
                    }
                }
            }
        }
    }
}

fun encodeFileName(fileName: String): String {
    return fileName.replace(" ", "%20")
        .replace(":", "%3A")
        .replace("-", "%2D")
        .replace(".", "%2E")
    // Add other characters as needed
}
